import { getEmojisGroupedBy } from 'unicode-emoji';
import type { BaseEmoji, EmojiVariation } from 'unicode-emoji';

export type { BaseEmoji, EmojiVariation };

export interface EmojiCategory {
  label: string;
  emojis: BaseEmoji[];
}

const GROUP_LABELS: Record<string, string> = {
  'smileys-emotion': 'Smileys & Emotion',
  'people-body': 'People & Body',
  'animals-nature': 'Animals & Nature',
  'food-drink': 'Food & Drink',
  'travel-places': 'Travel & Places',
  'activities': 'Activities',
  'objects': 'Objects',
  'symbols': 'Symbols',
  'flags': 'Flags',
};

const grouped = getEmojisGroupedBy('group', { versionAbove: '15.0' });

export const EMOJI_CATEGORIES: EmojiCategory[] = Object.entries(grouped)
  .filter(([group]) => group !== 'component')
  .map(([group, emojis]) => ({
    label: GROUP_LABELS[group] || group,
    emojis,
  }));

export const SKIN_TONES = [
  { emoji: '', label: 'Default' },
  { emoji: '🏻', label: 'Light' },
  { emoji: '🏼', label: 'Medium-Light' },
  { emoji: '🏽', label: 'Medium' },
  { emoji: '🏾', label: 'Medium-Dark' },
  { emoji: '🏿', label: 'Dark' },
];

export function getEmojiWithSkinTone(emoji: BaseEmoji, skinToneEmoji: string): string {
  if (!skinToneEmoji || !emoji.variations?.length) return emoji.emoji;
  const match = emoji.variations.find((v: EmojiVariation) => v.emoji.includes(skinToneEmoji));
  return match?.emoji || emoji.emoji;
}

export const QUICK_REACTIONS = ['👍', '👎', '❤️', '🎉', '🚀', '👀', '🔥', '💯', '⭐', '🤔', '😄', '😢', '✅', '❌'];
